import {connect} from 'react-redux'

import * as types from './constants'
import {mapStateToProps} from './container'
import TogglesView from './view'

const handleChange = (filtering) => ({
  type: types.ACTIVE_FILTER_CHANGED,
  filtering
})

const mapDispatchToProps = (dispatch) => ({
  handleChange: (filtering) => {
    dispatch(handleChange(filtering))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(TogglesView)


// WEBPACK FOOTER //
// ./src/ui/active-filter/toggles.jsx